class FfDropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.ffInit(true);

    document
      .querySelectorAll("[data-ff-closer-drawer-id='" + this.id + "']")
      .forEach((drawerCloserEl) => {
        drawerCloserEl.addEventListener("click", this.ffClose);
      });

    document
      .querySelectorAll("[data-ff-opener-drawer-id='" + this.id + "']")
      .forEach((drawerCloserEl) => {
        drawerCloserEl.addEventListener("click", this.ffOpen);
      });
  }

  ffToggle = (e) => {
    if (this.ffIsOpen == true) {
      this.ffClose();
    } else {
      this.ffOpen();
    }
  };

  ffOpenCloseAction = () => {};

  ffOpen = () => {
    const windowHeight = window.innerHeight;
    this.ffIsOpen = true;
    document.body.classList.add("ff-drawer-active");
    document.body.dataset.ffDrawerActive = this.id;
    this.style.display = "";
    const drawerContent =
      this.ffDrawerContent?.querySelector(".ff-drawer_content");
    if (drawerContent) {
      drawerContent.style.height = "100%";
      this.ffOpenCloseAction = () => {
        this.style.setProperty(
          "--ff-drawer-content-height",
          drawerContent?.scrollHeight + "px"
        );
      };
    } else {
    }
    this.ffOpenCloseAction = () => {};
    const { top } = this.getBoundingClientRect();
    const drawerHeight = windowHeight - top;
    this.style.setProperty("--ff-drawer-height", drawerHeight + "px");
    this.classList.add("ff-drawer-open");
    requestAnimationFrame(() => {
      if (drawerContent) {
        drawerContent.style.height = "";
      }
    });
    //@ts-ignore
    const { offsetLeft, offsetWidth } = this.querySelector(
      "#ff-drawer-container-dimensions"
    );
    this.style.setProperty(
      "--ff-drawer-container-dimension-left",
      offsetLeft + "px"
    );
    this.style.setProperty(
      "--ff-drawer-container-dimension-width",
      offsetWidth + "px"
    );
  };

  ffClose = () => {
    this.ffIsOpen = false;
    this.ffOpenCloseAction = () => {
      this.style.display = "none";
      document.body.classList.remove("ff-drawer-active");
      document.body.dataset.ffDrawerActive = "";
    };
    this.classList.remove("ff-drawer-open");
  };

  ffInit() {
    //drawer content has class 'ff-drawer-container' which has the transition
    this.ffDrawerContent = this.querySelector("[data-ff-drawer-content]");

    this.ffDrawerContent?.addEventListener("transitionend", (e) => {
      if (e.target == this.ffDrawerContent) {
        this.ffOpenCloseAction();
      }
    });
  }
}

if (!customElements.get("ff-dropdown-menu")) {
  customElements.define("ff-dropdown-menu", FfDropdownMenu);
}
